import { PayloadAction } from '@reduxjs/toolkit';
import { takeLatest, put } from 'redux-saga/effects';
import { User, UserStatus } from 'api/models';
import { UserAPI } from 'api/user';
import {
  deactivateMemberAction,
  MemberManagementPayload,
  reactivateMemberAction,
} from '../actions';
import { updateMember } from '../slice';

function* onError(
  user: Pick<User, 'userId' | 'userStatus'>,
  handleFailure = () => {},
) {
  yield put(
    updateMember({
      user: {
        userId: user.userId,
        userStatus: user.userStatus,
      },
    }),
  );
  handleFailure();
}

function* deactivateMemberSaga(action: PayloadAction<MemberManagementPayload>) {
  const {
    payload: { userId, handleSuccess, handleFailure },
  } = action;

  try {
    yield put(
      updateMember({
        user: {
          userId,
          userStatus: UserStatus.Inactive,
        },
      }),
    );

    const state = yield UserAPI.deactivateUser(userId);

    if (state) {
      if (handleSuccess) {
        handleSuccess();
      }
    } else {
      yield onError(
        {
          userId,
          userStatus: UserStatus.Active,
        },
        handleFailure,
      );
    }
  } catch (error) {
    yield onError(
      {
        userId,
        userStatus: UserStatus.Active,
      },
      handleFailure,
    );
  }
}

function* reactivateMemberSaga(action: PayloadAction<MemberManagementPayload>) {
  const {
    payload: { userId, handleSuccess, handleFailure },
  } = action;

  try {
    yield put(
      updateMember({
        user: {
          userId,
          userStatus: UserStatus.Active,
        },
      }),
    );

    const state = yield UserAPI.reactivateUser(userId);

    if (state) {
      if (handleSuccess) {
        handleSuccess();
      }
    } else {
      yield onError(
        {
          userId,
          userStatus: UserStatus.Inactive,
        },
        handleFailure,
      );
    }
  } catch (error) {
    yield onError(
      {
        userId,
        userStatus: UserStatus.Inactive,
      },
      handleFailure,
    );
  }
}

export const watchDeactivateMemberSaga = function* (): Generator {
  yield takeLatest(deactivateMemberAction.type, deactivateMemberSaga);
};
export const watchReactivateMemberSaga = function* (): Generator {
  yield takeLatest(reactivateMemberAction.type, reactivateMemberSaga);
};
